<div aria-hidden="true" class="d-flex justify-content-center">
    <sam4-spinner></sam4-spinner>
</div>
